import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";

import React from "react";

import { RefinementListConnectorParams } from "instantsearch.js/es/connectors/refinement-list/connectRefinementList";
import { useRefinementList } from "react-instantsearch-hooks-web";

function RefinementList(props: RefinementListConnectorParams) {
    const { items, refine } = useRefinementList({ ...props, sortBy: ["count"] });

    return (
        <FormGroup row sx={{ justifyContent: "center" }}>
            {items.map((item) => (
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={item.isRefined}
                            onChange={() => refine(`${item.value}`)}
                        />
                    }
                    label={`${item.label} (${item.count})`}
                />
            ))}
        </FormGroup>
    );
}

export default RefinementList;
